/**
 * The icon set, assembled by hand.
 *
 * The design system's Icon component looks names up in `window.lucide.icons`.
 * Importing lucide's barrel would pull in all ~1743 icons and add roughly
 * 700 kB for the two dozen this app uses, so each is imported individually and
 * the lookup table is built here — same approach as the sibling web apps.
 *
 * Icon renders `icons[pascal(name)] || icons[name]`, so keys are PascalCase.
 * A missing entry renders nothing at all rather than throwing, so grep this
 * file first if an icon goes blank.
 */

import {
  AlertTriangle,
  Archive,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  Bell,
  Check,
  ChevronDown,
  ChevronsRight,
  Clock,
  Copy,
  Crosshair,
  Download,
  Link2,
  Loader2,
  MessageSquare,
  Pencil,
  Plus,
  RotateCcw,
  Send,
  Settings,
  Sparkles,
  Trash2,
  User,
  X
} from 'lucide';

export const iconSet: Record<string, unknown> = {
  AlertTriangle,
  Archive,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  Bell,
  Check,
  ChevronDown,
  ChevronsRight,
  Clock,
  Copy,
  Crosshair,
  Download,
  Link2,
  Loader2,
  MessageSquare,
  Pencil,
  Plus,
  RotateCcw,
  Send,
  Settings,
  Sparkles,
  Trash2,
  User,
  X
};
